<template>  
  <router-view />      
  <LoadSpinner v-if="spin.loading" />  
</template>

<script>
import LoadSpinner from "./components/LoadSpinner/LoadSpinner.vue";


export default {
  name: 'App',
  components: {    
    LoadSpinner
  },
  data() {
    return {
      spin: {
        loading:false
      }
    }
  },
  provide() {
    return {
      mySpinner:this.spin
    }
  }
}
</script>

<style lang="css">
  @import"./assets/css/_colors";
  @import"./app.css";      
</style>
